var _path, _g, _path2, _path3, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVccSplit = function SvgVccSplit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FCBA34",
    fillRule: "evenodd",
    d: "M12 4.9 8 2.231v-.731A1 1 0 0 1 9 .5h6a1 1 0 0 1 1 1v.733l-4 2.666zm0 1.2 4-2.666V7.5a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V3.435z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75,
    transform: "matrix(.5 0 0 .5 0 .5)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#1e88e5",
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M2 4h12v3H2z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 2,
    d: "M8 0v16"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#666",
    strokeDasharray: "2 1",
    strokeWidth: 2,
    d: "M8 0v16"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#333"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9.5 6 1.725 1.725L9.05 9.9l1.05 1.05 2.175-2.175L14 10.5V6zM6.5 6H2v4.5l1.725-1.725L7.25 12.3V18h1.5v-6.3L4.775 7.725z"
  }))));
};
export default SvgVccSplit;